import { twMerge } from "tailwind-merge";
import { forwardRef } from "react";
import { TableRowBase, type TableRowBaseProps } from "@core/ui";

export type Props = Omit<TableRowBaseProps, "data-testid">;

/**
 * Styled table row wrapping TableRowBase.
 */
export const TableRow = forwardRef<HTMLTableRowElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <TableRowBase
        ref={ref}
        className={twMerge(
          "border-b border-border transition-colors flex flex-col md:table-row",
          className
        )}
        data-testid="table-row"
        {...props}
      />
    );
  }
);

TableRow.displayName = "TableRow";

export default TableRow;

